import { render, staticRenderFns } from "./AntiScamWorkStatistic.vue?vue&type=template&id=49dcf54f"
import script from "./AntiScamWorkStatistic.vue?vue&type=script&lang=js"
export * from "./AntiScamWorkStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports